import type { ColorMode, IColor } from '@color';
import { colorsEqual } from '@color';
import type { LineSegment } from '@geom';
import type { ArrowType } from '@visual';

export interface ConnectArrow {
  line: LineSegment;
  color: IColor;
  colorMode: ColorMode;
  headType?: ArrowType;
  tailType?: ArrowType;
}

export function connectArrowEquals(
  a: ConnectArrow | undefined,
  b: ConnectArrow | undefined
): boolean {
  if (a === b) {
    return true;
  }
  if (a === undefined || b === undefined) {
    return false;
  }
  if (a.headType !== b.headType || a.tailType !== b.tailType) {
    return false;
  }
  if (!colorsEqual(a.color, b.color)) {
    return false;
  }
  return a.line.equals(b.line);
}
